import { ReactNode, useState } from "react";
import { HStack } from "../../../shared/src/Components/Stacks.ts";
import Subrina from "../../../shared/src/img/Subrina.tsx";
import styled from "styled-components";
import { Link } from "react-router";

const Container = styled.div`
    position: relative;
    display: flex;
    padding: var(--spacing-12);
    padding-inline: var(--spacing-6);
    align-items: center;
    justify-content: space-between;
`;

const AnimatedParagraph = styled.p`
    display: flex;
    position: relative;
    color: var(--text);
    overflow: hidden;
    background: linear-gradient(
        to right,
        var(--text) 0%,
        var(--text) 25%,
        rgba(0, 255, 0, 0.8) 50%,
        var(--text) 75%,
        var(--text) 100%
    );
    background-size: 400% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: background-position 0.3s linear;

    &.animate {
        animation: gradientMove 0.5s linear;
    }

    @keyframes gradientMove {
        0% {
            background-position: 0;
        }
        100% {
            background-position: -150%;
        }
    }
`;

const Header = ({ children }: { children: ReactNode }) => {
    const [isAnimating, setIsAnimating] = useState(false);

    return (
        <Container>
            <Link to={"/"} style={{ textDecoration: "none" }}>
                <HStack gap={"6"} onMouseEnter={() => setIsAnimating(true)}>
                    <Subrina size={25} />
                    <AnimatedParagraph
                        className={isAnimating ? "animate" : ""}
                        onAnimationEnd={() => setIsAnimating(false)}
                    >
                        subscrypto
                    </AnimatedParagraph>
                </HStack>
            </Link>
            {children}
        </Container>
    );
};

export default Header;
